(function () {
  // Keep browser chrome black across sections and modal states.
  var meta = document.getElementById('mnl-browser-theme');
  if (meta) meta.setAttribute('content', '#000000');
  document.documentElement.style.setProperty('--mnl-browser-color', '#000000');
})();
